import * as yup from 'yup';

export const initialValues = {
  salaryRequirement: {
    value: '',
    currency: 'BRL',
  },
  linkedin: '',
};

const message = 'Verificamos que a sua pretensão salarial está fora da média da nossa base de dados, por favor confira os dados.';

const schema = yup.object().shape({
  salaryRequirement: yup.object().shape({
    value: yup
      .string()
      .required('A pretensão salarial é obrigatório')
      .test('range', message, str => {
        const val = parseInt(str?.replace(/[^\d]/g, ''), 10);
        if (val < 1000) {
          return false;
        }
        if (val > 50000) {
          return false;
        }
        if (isNaN(val)) {
          return false;
        }
        return true;
      }),
    currency: yup.string().required(''),
  }),
  linkedin: yup.string()
    .matches(/^(https:\/\/)?(www\.)?linkedin\.com\/in\/.+/, {
      message: 'URL inválida. Padrão https://www.linkedin.com/in/[nome]',
      allowEmpty: true,
    }),
});

export default schema;
